export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Bulk editing",
    title: "Bulk calendar",
    subtitle: "Close, open or adjust several units at once.",
  },
  actions: {
    close: {
      label: "Close dates",
      hint: "Applies a manual block while respecting bookings and sync.",
    },
    open: {
      label: "Open dates",
      hint: "Reopens only the selected days without touching the rest of the block.",
    },
    price: {
      label: "Change price",
      hint: "Updates the nightly price for the chosen dates and accommodations.",
    },
    minStay: {
      label: "Minimum stay",
      hint: "Set the minimum nights per date in bulk.",
    },
  },
  microcopy: {
    close: "Manual block",
    open: "Partial opening",
    price: "Nightly rate",
    minStay: "Minimum nights",
  },
  step1: {
    title: "What to apply",
    hintEmpty: "Choose an action to get started.",
  },
  step2: {
    title: "Where to apply",
    selectedCount: "{selected} of {total} selected",
    selectVisible: "Visible",
    selectAll: "All",
    clear: "Clear",
    searchPlaceholder: "Search accommodation…",
    empty: "No accommodations match your search.",
  },
  step3: {
    title: "Range and days",
    datesInRange: "{count} date in range | {count} dates in range",
    from: "From",
    to: "To",
    presetAll: "All",
    presetWeekdays: "Mon–Fri",
    presetWeekend: "Weekend",
  },
  step4: {
    closeReasonTitle: "Close reason",
    availabilityTitle: "Availability",
    closeReasonHint: "Optional — it will be saved with the block.",
    availabilityHint: "Sales are closed (stop-sell); availability is kept. Change it only if you want to.",
    closeCommentPlaceholder: "e.g. maintenance or owner use",
    availabilityPlaceholder: "Rooms on sale (empty = keep)",
    openAvailabilityHint: "Reopens sales. Enter how many rooms to offer (empty = keep the current).",
    availabilityPlaceholderOpen: "Rooms on sale",
  },
  ratePlan: {
    title: "Rate to modify",
    hint: "This type has several rates. Choose which one(s) to apply {target} to. Derived rates adjust automatically.",
    targetPrice: "the price",
    targetMinStay: "the minimum stay",
    default: "standard",
    roomsCount: "{count} room | {count} rooms",
    multiUnitNote: "It will apply to every room that has the chosen rate.",
    fallbackName: "Rate",
  },
  price: {
    title: "New nightly price",
    hint: "It will apply to the chosen dates, units and rates.",
    mixedCurrencyWarning: "Select only accommodations with the same currency.",
    placeholder: "Value",
    placeholderCurrency: "Value in {currency}",
    hintPercent: "It raises or lowers the price each night already has.",
    modeGroupLabel: "Type of price change",
    modeFixed: "Fixed price",
    modeFixedHint: "The same amount on every night.",
    modePercent: "Percentage",
    modePercentHint: "Based on each night's own price.",
    modeAmount: "Amount",
    modeAmountHint: "Add or subtract on each night.",
    amountPlaceholder: "e.g. 10",
    amountHint: "Added to what each night already costs. Use the − sign to lower it.",
    percentPlaceholder: "e.g. 20",
    percentHint: "Every night is recalculated from its own price. The − sign lowers it (between {min} % and {max} %).",
    toggleSign: "Switch between raise and lower",
    invalidPercent: "Enter a percentage between {min} % and {max} %, other than 0.",
  },
  minStay: {
    title: "Minimum stay",
    hint: "Minimum number of nights per date.",
    placeholder: "e.g. 2",
  },
  summary: {
    empty: "Select units and range.",
    unitOne: "unit",
    unitMany: "units",
    dateOne: "date",
    dateMany: "dates",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} ready to apply.",
    nightOne: "night",
    nightMany: "nights",
    readyPriceFixed: "{propertyCount} {propertyLabel} · will set {price} {currency} on {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · will raise {dateCount} {nightLabel} by {amount} {currency}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · will lower {dateCount} {nightLabel} by {amount} {currency}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · will raise the price of {dateCount} {nightLabel} by {percent} %.",
    readyPriceDown: "{propertyCount} {propertyLabel} · will lower the price of {dateCount} {nightLabel} by {percent} %.",
  },
  footer: {
    cancel: "Cancel",
    apply: "Apply changes",
    applying: "Applying…",
  },
  weekdays: {
    mon: { short: "M", long: "Monday" },
    tue: { short: "T", long: "Tuesday" },
    wed: { short: "W", long: "Wednesday" },
    thu: { short: "T", long: "Thursday" },
    fri: { short: "F", long: "Friday" },
    sat: { short: "S", long: "Saturday" },
    sun: { short: "S", long: "Sunday" },
  },
  ownerBlockComment: "Blocked by the owner",
};
